import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=945283fe&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=ts&"
export * from "./index.page.vue?vue&type=script&lang=ts&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=945283fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945283fe",
  null
  
)

export default component.exports
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCarousel,QCarouselSlide,QIcon,QSpinnerDots,QCarouselControl,QBtn});
